export default {
  API_KEY: 'ygx2YMj79KH8IaJaTRH5gcLfNGMTuIhH',
};
